'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import devLogger from 'react-utils/devLogger';
import React, { Component } from 'react';
import UIAvatar from './UIAvatar';

var UISimpleAvatar = /*#__PURE__*/function (_Component) {
  _inherits(UISimpleAvatar, _Component);

  function UISimpleAvatar() {
    _classCallCheck(this, UISimpleAvatar);

    return _possibleConstructorReturn(this, _getPrototypeOf(UISimpleAvatar).apply(this, arguments));
  }

  _createClass(UISimpleAvatar, [{
    key: "render",
    value: function render() {
      devLogger.warn({
        message: 'UISimpleAvatar is depreciated, please use UIAvatar or UIImage please',
        key: 'UISimple-avatar-is-out'
      });
      return React.createElement(UIAvatar, this.props);
    }
  }]);

  return UISimpleAvatar;
}(Component);

UISimpleAvatar.propTypes = UIAvatar.propTypes;
export default UISimpleAvatar;